export const enum authenticationIntentIds {
    Unknown = 1,
    Accounts = 4
}
